$(document).ready(function() {
  if ($('#payment-form').length > 0 && $('.amount-div').length > 0){
    checkAmount('.amount', '.amount-div')
  }
});
